import axios from "axios";
import {
  GET_CHECK_IN_REQUEST,
  GET_CHECK_IN_SUCCESS,
  GET_CHECK_IN_FAIL,
} from "../../types/admin/checkInTypes";

export const getCheckInAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CHECK_IN_REQUEST,
    });

    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth-dashboard/check-in/`,
      config
    );

    dispatch({
      type: GET_CHECK_IN_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    console.error("Full error object:", error);

    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);

    if (!err) {
      err = "Network Error";
    }

    console.error("Processed error:", err);

    dispatch({
      type: GET_CHECK_IN_FAIL,
      payload: err,
    });

    throw err;
  }
};
